<span class="mr-1" *ngIf="title">{{ title }}</span>
<ng-container *ngIf="tooltipValue">
  <img enTooltip [attr.data-placement]="placement" data-toggle="tooltip" data-animation="false"
    [attr.title]="tooltipValue" src="/assets/images/info-{{color}}.png" alt="Info Icon" />
</ng-container>